import React from "react";
import QualityImg from "../assets/images/new-dashboards/quality.png";
import SafetyIcon from "../assets/icons/safety.png";
import TraceabilityIcon from "../assets/icons/traceability.png";
import RegulationsIcon from "../assets/icons/regulations.png";
import { ContactForm } from "../components/ContactForm";

export function LucidQuality() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca Quality</h3>
        <p className="body-text white">
          Quality is key in manufacturing processes. Elevate and optimize your
          quality program with the Alpaca Quality app, designed to provide
          customers with reassurance your QA/QC and traceability standards are
          met.
        </p>
        <img
          src={QualityImg}
          alt="Alpaca Quality Dashboard"
          className="module-img"
        />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            The powerful Alpaca Quality app allows users to produce higher
            quality with more consistency in less time. The app centralizes and
            stores inspection reports and quality documents, including:
            <strong>
              {" "}
              NCRs, DIRs, Engineering Requests, Engineering Data Sheets,
              Assembly inspection Reports and Traceability Reports.{" "}
            </strong>
          </p>
          <p className="body-text left">
            This app is intuitive and easy to use, and can be downloaded onto
            any tablet. It comes with built-in intelligence to identify
            documents based on their attributes and confirms standards are met,
            simplifying the process for users. Any deviations are automatically
            flagged by the app and a Non-Conformance Report (NCR) is generated
            and emailed to key users.
          </p>
          <p className="body-text left">
            Alpaca Quality integrates seamlessly into MRP, data is captured at
            the source eliminating costly post-event data entry and the errors
            it creates.
          </p>
        </div>

        <div>
          <div className="container-img-text">
            <img src={SafetyIcon} alt="Safety Icon" />
            <div>
              <h3 className="smallSubhead">Improve Quality</h3>
              <p className="small-text">
                Safety is always a priority in the manufacturing industry.
                Alpaca Quality makes it easy to generate reports and track
                incidents.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={TraceabilityIcon} alt="Traceability Icon" />
            <div>
              <h3 className="smallSubhead">Easy Traceability</h3>
              <p className="small-text">
                By digitizing the quality assurance procedures you assure
                improved adherence and full traceability.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={RegulationsIcon} alt="Regulations Icon" />
            <div>
              <h3 className="smallSubhead">Keep Up With Regulations</h3>
              <p className="small-text">
                Make quality control inspections and audits a breeze with Alpaca
                Quality. In the app, all data is stored in one place for easy
                access. Proof of compliance will be just a few clicks away,
                saving you time, and money.
              </p>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </>
  );
}
